module.exports = __webpack_public_path__ + "img/IT0000162899448.d8edf2ae.png";